import React, { useEffect, useRef, useState } from 'react'

const TYPING = {
  SPEED_MS: 140,
  DELETE_SPEED: 95,
  PAUSE_MS: 1000,
} as const

type AnimationState = {
  wordIndex: number
  charIndex: number
  phase: 'typing' | 'deleting'
}

type TypewriterWordsProps = {
  words: string[]
}

function TypewriterWords({ words }: TypewriterWordsProps) {
  const [displayedWord, setDisplayedWord] = useState('')
  const animRef = useRef<AnimationState>(null)

  useEffect(() => {
    animRef.current = { wordIndex: 0, charIndex: 0, phase: 'typing' }
    setDisplayedWord('')
    let timeoutId: ReturnType<typeof setTimeout>

    const tick = () => {
      if (!animRef.current) return
      const anim = animRef.current
      const word = words[anim.wordIndex]

      if (anim.phase === 'typing') {
        anim.charIndex++
        setDisplayedWord(word.slice(0, anim.charIndex))
        if (anim.charIndex >= word.length) {
          anim.phase = 'deleting'
          timeoutId = setTimeout(tick, TYPING.PAUSE_MS)
        } else {
          timeoutId = setTimeout(tick, TYPING.SPEED_MS)
        }
      } else {
        anim.charIndex--
        setDisplayedWord(word.slice(0, anim.charIndex))
        if (anim.charIndex <= 0) {
          anim.wordIndex = (anim.wordIndex + 1) % words.length
          anim.phase = 'typing'
          timeoutId = setTimeout(tick, TYPING.PAUSE_MS)
        } else {
          timeoutId = setTimeout(tick, TYPING.DELETE_SPEED)
        }
      }
    }

    timeoutId = setTimeout(tick, TYPING.SPEED_MS)
    return () => clearTimeout(timeoutId)
  }, [words])

  return <span>{displayedWord}</span>
}

export default TypewriterWords
